import { useWhatsappComercialModel } from '../../../modelos/Whatsapp/modeloWhatsappComercial';
import React, { useState, useEffect, useRef } from 'react';
import UserCard from './componentes/UserCard';

import { ImagenModal } from './utilsWhatsapp/ImagenModal';

import { VideoModal } from './utilsWhatsapp/VideoModa';
import ContextMenu from '../../../components/ContextMenu';
import ChatComponent from './componentes/ChatComponent';

const ModuloWhatsapp = () => {
  // Estado para toda la aplicación
  const [chatActivoId, setChatActivoId] = useState(null);

  const [nuevoMensaje, setNuevoMensaje] = useState("");
  // archivo para envio
  const [archivosEnvio, setarchivosEnvio] = useState({
      archivo: null,
  });
  const [isRecording, setIsRecording] = useState(false);

  const [isSending, setIsSending] = useState(false);

  const {
    usuarios,
    idChatActualizado,
    setIdChatActualizado,
    loadingUsuarios,
    errorUsuarios,
    cargarTodosLosUsuarios,

    // mensajes
    mensajes,
    loadingmensajes,
    errormensajes,
    cargarTodosLosMensajes,

    enviarMensaje,

    updateUsuario
  } = useWhatsappComercialModel();

  // imagenes
  const [imagenEnModal, setImagenEnModal] = useState(null);
  const abrirModalImagen = (url) => setImagenEnModal(url);
  const cerrarModalImagen = () => setImagenEnModal(null);

  // videos
  const [videoEnModal, setVideoEnModal] = useState(null);
  const abrirModalVideo = (url) => setVideoEnModal(url);
  const cerrarModalVideo = () => setVideoEnModal(null);

  //estado para menu 
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    selectedChatId: null,
  });

  // apuntar al final de la lista de mensajes
  const finDeMensajesRef = useRef(null);

  const scrollToBottom = () => {
    finDeMensajesRef.current?.scrollIntoView({ behavior: "auto" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [mensajes]);

  // cargar chats de api
  useEffect(() => {
    cargarTodosLosUsuarios("DUFY ASESORIAS");
  }, []);

  // cargar mensajes desde la api
  useEffect(() => {
    if (!chatActivoId) return;
    cargarTodosLosMensajes("DUFY ASESORIAS", chatActivoId);
  }, [chatActivoId]);

  // verificar animacion y resetear
  useEffect(() => {
    if (idChatActualizado) {
      const timer = setTimeout(() => {
        setIdChatActualizado(null); 
      }, 1600);

      return () => clearTimeout(timer);
    }
  }, [idChatActualizado]);

  const handleEnviarMensaje = async () => {
    if (nuevoMensaje.trim() === "" && !archivosEnvio.archivo) {
      return; 
    }
    
    setIsSending(true);
    console.log(`Enviando a chat ${chatActivoId}: "${nuevoMensaje}"`);
    
    try {
      
      await enviarMensaje(chatActivoId, nuevoMensaje, archivosEnvio);
      
      // ✅ Limpiar estados solo después del envío exitoso
     
      setNuevoMensaje("");
      setarchivosEnvio({ archivo: null });
      setIsRecording(false);
      
      console.log('✅ Mensaje enviado exitosamente');
      
    } catch (error) {
      console.error('❌ Error al enviar mensaje:', error);
    } finally{
      setIsSending(false);
    }
  };

  // ✅ Función específica para manejar audio
  const handleSendAudio = async (audioFile) => {
    console.log('📁 Archivo de audio recibido:', {
      name: audioFile.name,
      type: audioFile.type,
      size: audioFile.size
    });

    if (!chatActivoId) {
      console.error('❌ No hay chat activo seleccionado');
      setIsRecording(false);
      return;
    }

    try {
      // Enviar directamente el archivo de audio
      await enviarMensaje(chatActivoId, "", { archivo: audioFile });
      
      // ✅ Limpiar estados después del envío exitoso
      setarchivosEnvio({ archivo: null });
      setIsRecording(false);
      
      console.log('✅ Audio enviado exitosamente');
      
    } catch (error) {
      console.error('❌ Error al enviar audio:', error);
      // Limpiar estados en caso de error también
      setarchivosEnvio({ archivo: null });
      setIsRecording(false);
      // Aquí podrías mostrar un mensaje de error al usuario
    } finally {
      setIsSending(false); // Desbloqueamos la UI
    }
  };

  // ✅ Función para cancelar grabación
  const handleCancelRecording = () => {
    console.log('🚫 Grabación cancelada por el usuario');
    setIsRecording(false);
    setarchivosEnvio({ archivo: null });
  };

  // ✅ Función para iniciar grabación
  const handleStartRecording = () => {
    if (!chatActivoId) {
      console.warn('⚠️ No hay chat activo seleccionado');
      return;
    }
    console.log('🎤 Iniciando grabación de audio');
    setIsRecording(true);
  };

  const getChatActivo = () => usuarios.find(chat => chat.phone_number === chatActivoId);

  //menu context
  const handleContextMenu = (event, chatId) => {
    event.preventDefault(); // ¡Muy importante para prevenir el menú nativo del navegador!
    setContextMenu({
      visible: true,
      x: event.pageX, // Coordenada X del clic
      y: event.pageY, // Coordenada Y del clic
      selectedChatId: chatId,
    });
  };
  const handleCloseContextMenu = () => {
    setContextMenu({ ...contextMenu, visible: false });
  };
  const handleChangeLabel = async (newLabel) => {
    const { selectedChatId } = contextMenu;

    await updateUsuario(selectedChatId,'label',newLabel);

    handleCloseContextMenu();
  };
  const handleArchivo = async (newArchivo) =>{
    const { selectedChatId } = contextMenu;

    await updateUsuario(selectedChatId,'archivo',true);

    handleCloseContextMenu();
  }
  const menuOptions = [
    { label: 'Marcar como Nuevo', action: () => handleChangeLabel('NUEVO') },
    { label: 'Marcar como Cotizando', action: () => handleChangeLabel('COTIZANDO') },
    { label: 'Marcar como A pagar', action: () => handleChangeLabel('A PAGAR') },
    { label: 'Marcar como Pagado', action: () => handleChangeLabel('PAGADO') },
    { label: 'Marcar como Archivado', action: () => handleArchivo() },
  ];

  if (loadingUsuarios) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-2 text-gray-600">Cargando Chats...</p>
        </div>
      </div>
    );
  }

  if (!usuarios) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-red-500 border-r-transparent"></div>
          <p className="mt-2 text-red-600">Error: No se pudieron cargar los chats</p>
        </div>
      </div>
    );
  }

  const selectChatActivo = (idDelChatSeleccionado) => {
    console.log(`Cambiando al chat con ID: ${idDelChatSeleccionado}`);
    
    // ✅ Si hay una grabación en curso, cancelarla al cambiar de chat
    if (isRecording) {
      setIsRecording(false);
      setarchivosEnvio({ archivo: null });
    }
    
    setChatActivoId(idDelChatSeleccionado);
  };

  return (
    <div className="flex h-[90vh] font-sans border border-gray-300 rounded-lg overflow-hidden bg-white">
      
      {/* Columna Izquierda: Lista de Chats */}
      <div className="w-1/3 border-r border-gray-200 flex flex-col">
        <div className="p-4 border-b border-gray-200 bg-gray-50">
          <h2 className="text-xl font-bold">Chats</h2>
        </div>
        <div className="overflow-y-auto flex-grow">
          {usuarios.map(chat => (
            <UserCard 
              key={chat.phone_number}
              chat={chat} 
              chatActivoId={chatActivoId} 
              onSetActivo={selectChatActivo}
              idChatActualizado={idChatActualizado}
              onContextMenu={handleContextMenu}
            />
          ))}
        </div>
      </div>

      <ChatComponent
        chat={getChatActivo()}
        mensajes={mensajes}
        loadingMensajes={loadingmensajes}
        nuevoMensaje={nuevoMensaje}
        archivosEnvio={archivosEnvio}
        isRecording={isRecording}
        isSending={isSending}
        onEnviarMensaje={handleEnviarMensaje}
        onEnviarAudio={handleSendAudio}
        onNuevoMensajeChange={setNuevoMensaje}
        onArchivosEnvioChange={setarchivosEnvio}
        onStartRecording={handleStartRecording}
        onCancelRecording={handleCancelRecording}
        onAbrirImagen={abrirModalImagen}
        onAbrirVideo={abrirModalVideo}
      />

      {/* Modales */}
      {imagenEnModal && (
        <ImagenModal 
          imageUrl={imagenEnModal} 
          onClose={cerrarModalImagen} 
        />
      )}
      {videoEnModal && (
        <VideoModal 
          videoUrl={videoEnModal} 
          onClose={cerrarModalVideo} 
        />
      )}

      {/* Renderiza el menú contextual condicionalmente */}
      {contextMenu.visible && (
        <ContextMenu
          x={contextMenu.x}
          y={contextMenu.y}
          options={menuOptions}
          onClose={handleCloseContextMenu}
        />
      )}

    </div>
  );
};

export default ModuloWhatsapp;